/* ==========================================================================
   VLB PLP Card V2 — hardcode of FigPii experiment 359913
   (M_PLP_Product_Card_Optimization_V2). Handles only what card-product.liquid
   / vlb-plp-card-v2.css can't do server-side: initialising Swiper on the
   mobile gallery, whole-card tap-to-navigate, and re-initialising after the
   filter drawer swaps the grid's markup out from under it.

   Vanilla JS, no build step, no framework. Loaded with defer, after
   swiper-bundle.min.js (layout/theme.liquid). Must stay inert — never throw —
   on any page/breakpoint plp_v2 doesn't touch: window.Swiper missing, or no
   [data-vlb-plp-gallery] on the page (it's only ever rendered by
   card-product.liquid when plp_v2 is true, i.e. two of the theme's thirteen
   card-product call sites).
   ========================================================================== */
(function () {
  'use strict';

  // Matches the max-width in vlb-plp-card-v2.css — keep the two in step.
  // Swiper only ever runs at or below this: above it the CSS hands the card
  // back to .card__media and the gallery is display: none, so there is no
  // reason to spin up an instance for a hidden 0×0 element.
  var MOBILE_BREAKPOINT = 989;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  /* Initialise (or re-initialise) Swiper on every V2 gallery currently in the
     DOM. Mirrors initSwipers() in the FigPii test's Shared/shared.tsx, minus
     the Anacobra class-prefixing and the slide.remove() slide cap —
     card-product.liquid already renders at most 4 slides for V2 via its
     `limit:` param. FigPii experiment 359913. */
  /* Every Swiper this script has created. The grid re-render detaches the
     cards it was built on, so their instances have to be torn down rather
     than left holding listeners on orphaned nodes. FigPii experiment 359913. */
  var instances = [];

  function destroyDetachedInstances() {
    instances = instances.filter(function (swiper) {
      if (swiper.destroyed) return false;
      if (document.contains(swiper.el)) return true;
      // Element is already detached, so there are no styles worth cleaning.
      swiper.destroy(true, false);
      return false;
    });
  }

  function initGalleries() {
    if (!isMobile()) return;
    if (typeof window.Swiper !== 'function') return;

    var containers = document.querySelectorAll(
      '[data-vlb-plp-gallery] .mobile-swiper-gallery__swiper-container'
    );

    containers.forEach(function (container) {
      // Destroy an instance this script created earlier — e.g. before a
      // filter re-render swapped this card's markup out from under it. The
      // theme's own <swiper-gallery> custom element never claims these
      // nodes on V2 cards (card-product.liquid renders a plain div here
      // instead), so there is no pre-existing instance from elsewhere to
      // guard against.
      if (container.swiper) {
        container.swiper.destroy(true, true);
      }

      var prevEl = container.querySelector('.swiper-button-prev');
      var nextEl = container.querySelector('.swiper-button-next');
      var paginationEl = container.querySelector('.swiper-pagination');

      if (!paginationEl) {
        paginationEl = document.createElement('div');
        paginationEl.className = 'swiper-pagination';
        container.appendChild(paginationEl);
      }

      instances.push(new window.Swiper(container, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 5,
        loop: true,
        roundLengths: true,
        watchOverflow: true,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      }));
    });
  }

  /* Whole-card tap → the product page, via the .button__view-item link
     card-product.liquid renders (but vlb-plp-card-v2.css hides) for V2
     cards. Ignores clicks that land on a real <a>, so the real links inside
     the card keep their own behaviour. Mirrors the mobile branch of
     handleCardRedirect() in the test's Shared/shared.tsx.

     KNOWN, INHERITED FROM THE TEST: Swiper's pagination bullets are <span>s,
     not <a>s, so a tap on a dot advances the slide AND falls through to here
     and navigates away. The already-won FigPii variation behaved exactly the
     same way, so it is reproduced rather than fixed. To change it, add
     `|| event.target.closest('.swiper-pagination')` to the guard above.
     FigPii experiment 359913. */
  /* Everything a shopper can actually operate keeps its own behaviour. The test
     only listed <a>, which was enough when the card held nothing but links —
     it is not any more:
       - the wishlist star is a <button> inside <wishlist-star>, so a tap saved
         the product and then navigated away, and the "Added to your wishlist"
         banner was never on screen long enough to read;
       - Swiper's pagination bullets are <span>s, so a tap on a dot changed the
         slide AND opened the product.
     Matching on the whole interactive set rather than adding cases one at a
     time, so the next control dropped into this card is covered by default.
     FigPii experiment 359913. */
  var INTERACTIVE = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    '[role="button"]',
    'wishlist-star',
    '.swiper-pagination'
  ].join(',');

  function handleCardClick(event) {
    if (event.target.closest(INTERACTIVE)) return;

    var card = event.target.closest('.card-wrapper[data-plp-v2]');
    if (!card) return;

    var viewLink = card.querySelector('.button__view-item');
    if (!viewLink || !viewLink.href) return;

    window.location.href = viewLink.href;
  }

  /* Re-init whenever the grid is re-rendered. This is deliberately broader
     than the FigPii test's observeProductGrid(), which only armed a one-shot
     observer after a click on a filter option.

     The collection grid is rendered client-side by assets/filter.js (built
     from src/js/main/filter/App.jsx): it replaces #product-grid's innerHTML
     for filtering, for sorting AND for pagination — pagination links are
     intercepted with preventDefault() and turned into a `pagination:change`
     event, so paging never reloads the document. The test's filter-only hook
     therefore missed paging entirely: page 2 arrived with no carousel on any
     card and only a manual refresh brought it back. A persistent observer on
     #product-grid catches all three paths.

     childList WITHOUT subtree is the important part: the re-render replaces
     #product-grid's own children, which this sees, while Swiper's DOM churn
     (loop clones, state classes) happens deeper inside each card and so
     cannot retrigger this and spin forever.

     The 1-col/2-col view toggle needs nothing here — GridViewController
     (global.js) only swaps classes on #product-grid, and Swiper 10's
     resizeObserver, on by default, handles the resulting resize itself.
     FigPii experiment 359913. */
  function watchForGridUpdate() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var pending = null;
    var observer = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () {
        destroyDetachedInstances();
        initGalleries();
      }, 50);
    });

    observer.observe(grid, { childList: true });
  }

  // Debounced so a drawn-out resize (or a phone rotation, which fires
  // several) doesn't tear down and rebuild Swiper repeatedly mid-gesture.
  // Mirrors the test's onDeviceChange(() => this.reInit()).
  // FigPii experiment 359913.
  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initGalleries, 200);
  }

  function init() {
    // Defensive: do nothing at all on pages plp_v2 never renders on. A
    // collection whose first render is empty (every product filtered out)
    // has no gallery yet but does have #product-grid, so it still needs the
    // observer below — otherwise clearing the filter would bring cards back
    // with no carousel on them.
    if (!document.querySelector('[data-vlb-plp-gallery]') &&
        !document.getElementById('product-grid')) {
      return;
    }

    initGalleries();

    document.addEventListener('click', handleCardClick);
    watchForGridUpdate();
    window.addEventListener('resize', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
